var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col, Row, Spinner, Table } from "react-bootstrap";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import ErrorNotification, { ErrorDisplayType, } from "../../Generic/ErrorNotification";
import Loader from "@frameworks/shared-library/components/Loader";
import di from "./di/serviceLocator";
import { TodaysDate, futureDate, getBackMonths, getDateInFormat, getDaysDifference, getFinancialYear, subtractDays, } from "@domains/utils/reportDates";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import CalendarPopupDesk from "@frameworks/shared-library/components/Calendar/CalendarPopupDesk";
import SalesToasts from "@frameworks/shared-library/components/Toasts";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesReporting/SalesMTFReport.scss";
var MTFReport = function () {
    var _a = __read(React.useState(false), 2), loader = _a[0], setLoader = _a[1];
    var _b = __read(React.useState(false), 2), dateValidation = _b[0], setDateValidation = _b[1];
    var _c = __read(React.useState(getBackMonths(TodaysDate, 3)), 2), minDate = _c[0], setMinDate = _c[1];
    var _d = __read(React.useState([]), 2), holidayList = _d[0], setHolidayList = _d[1];
    var _e = __read(React.useState(new Date()), 2), maxDate = _e[0], setMaxDate = _e[1];
    var _f = __read(React.useState(""), 2), resDate = _f[0], setResDate = _f[1];
    var _g = __read(React.useState(false), 2), mtfDownloader = _g[0], setMTFDownloader = _g[1];
    var _h = __read(React.useState(getFinancialYear(new Date())), 2), finYear = _h[0], setFinYear = _h[1];
    var _j = __read(React.useState(), 2), customTime = _j[0], setCustomTime = _j[1];
    var _k = __read(React.useState([]), 2), mtfReportData = _k[0], setMTFReportData = _k[1];
    var filterDate = function (date) {
        var day = date.getDay();
        return day !== 0 && day !== 6;
    };
    var getEndDate = function (date, index) {
        while (date.getDay() === 0 ||
            date.getDay() === 6 ||
            (holidayList && (holidayList === null || holidayList === void 0 ? void 0 : holidayList.length) > 0 && holidayList.includes(date))) {
            date = subtractDays(date, index + 1);
        }
        return date;
    };
    var getStartDate = function (date, index) {
        while (date.getDay() === 0 ||
            date.getDay() === 6 ||
            (holidayList && (holidayList === null || holidayList === void 0 ? void 0 : holidayList.length) > 0 && holidayList.includes(date))) {
            date = subtractDays(date, index + 1);
        }
        return date;
    };
    var getStartAndEndDate = function () {
        var date = new Date(), index = 1;
        var dateObj = {
            startDate: null,
            endDate: null,
        };
        dateObj.endDate = getEndDate(date, index);
        index = 1;
        var localStartDate = subtractDays(dateObj.endDate, 2);
        dateObj.startDate = getStartDate(localStartDate, index);
        return dateObj;
    };
    var _l = __read(React.useState(getStartAndEndDate().startDate), 2), startDate = _l[0], setStartDate = _l[1];
    var _m = __read(React.useState(getStartAndEndDate().endDate), 2), endDate = _m[0], setEndDate = _m[1];
    var rangefilterDate = function (date) {
        return false;
    };
    var checkCustomValidations = function (startDate, endDate) {
        var isError = false;
        var daysDifference = getDaysDifference(startDate, endDate);
        if (holidayList) {
            holidayList.map(function (holiday) {
                if (startDate <= holiday && holiday <= endDate) {
                    daysDifference--;
                }
            });
        }
        if (daysDifference > 2) {
            isError = true;
            setDateValidation(true);
            setMTFReportData([]);
        }
        else {
            isError = false;
            getMTFReportData(startDate, endDate);
        }
        return isError;
    };
    var getValidationMessage = function () {
        var fromDate = getDateInFormat(startDate, "D-MMM-YY");
        var toDate = getDateInFormat(futureDate(startDate, 2, "days"), "D-MMM-YY");
        return "Selected Date range is not valid. You can select upto 3 maximum days";
    };
    var getHolidayList = function () {
        di.salesReporting
            .getHolidayList()
            .then(function (resp) {
            setHolidayList(resp);
        })
            .catch(function (resp) {
            setHolidayList([]);
        });
    };
    var downloadMTFReportData = function (fromDate, toDate) {
        setMTFDownloader(true);
        var dateObj = {
            fromDate: fromDate.toISOString(),
            toDate: toDate.toISOString(),
        };
        var reqPayload = {
            filterData: JSON.stringify(dateObj),
            isDownload: true,
            page: 1,
            pageSize: 10000,
        };
        di.salesReporting
            .getMTFReportingDownloadData(reqPayload)
            .then(function (resp) {
            base64toExcel(resp.downloadBase64String, "MTF_Reports " + getDateInFormat(new Date(), "DD_MM_YYYY") + ".xlsx");
            setMTFDownloader(false);
        })
            .catch(function (resp) {
            setMTFDownloader(false);
        });
    };
    var getMTFReportData = function (fromDate, toDate) {
        setLoader(true);
        var dateObj = {
            fromDate: fromDate.toISOString(),
            toDate: toDate.toISOString(),
        };
        var reqPayload = {
            filterData: JSON.stringify(dateObj),
            isDownload: false,
            page: 1,
            pageSize: 10000,
        };
        di.salesReporting
            .getMTFReportingDetails(reqPayload)
            .then(function (resp) {
            var _a;
            if (resp && ((_a = resp === null || resp === void 0 ? void 0 : resp.mtfPledgeLst) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setResDate(resp === null || resp === void 0 ? void 0 : resp.respDtm);
                setMTFReportData(resp === null || resp === void 0 ? void 0 : resp.mtfPledgeLst);
                setLoader(false);
            }
            else {
                setResDate("");
                setMTFReportData([]);
                setLoader(false);
            }
        })
            .catch(function (resp) {
            setResDate("");
            setMTFReportData([]);
            setLoader(false);
        });
    };
    var columnList = [
        { title: "Transaction Date " },
        { title: "Account Code " },
        { title: "Client Name" },
        { title: "Stock Name  " },
        { title: "Quantity" },
        { title: "Status" },
    ];
    React.useEffect(function () {
        getHolidayList();
        getMTFReportData(startDate, endDate);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(GridContainer, { parentClass: "mtf-primary-container" },
            React.createElement(Row, { className: "lead-tabs-row" },
                React.createElement(Col, { md: 9, lg: 9 },
                    React.createElement("div", { className: "mgt-5" },
                        React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" },
                            "From ",
                            getDateInFormat(startDate, "D-MMM-YY"),
                            " To",
                            " ",
                            getDateInFormat(endDate, "D-MMM-YY")),
                        React.createElement("span", { className: "mgl-15" },
                            React.createElement("i", { className: "edel-icon-calendar2 txt-midnight-blue" }),
                            React.createElement("span", { className: "mgl-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Change", onClick: function () { return setCustomTime(!customTime); } }))),
                        React.createElement("span", null, mtfDownloader ? (React.createElement("span", { className: "ps-4" },
                            React.createElement(Spinner, { animation: "border", variant: "primary", size: "sm" }))) : (React.createElement("span", { className: "position-relative", onClick: function () {
                                downloadMTFReportData(startDate, endDate);
                            } },
                            React.createElement("i", { className: "edel-icon-download-page hand_cursor h5 m-0 position-absolute ps-2 " },
                                React.createElement("span", { className: "path1" }),
                                React.createElement("span", { className: "path2" }),
                                React.createElement("span", { className: "path3" })))))),
                    React.createElement(CalendarPopupDesk, { startDate: startDate, endDate: endDate, finYear: finYear, setStartDate: setStartDate, setEndDate: setEndDate, setFinYear: setFinYear, isMinDate: true, otherMinDate: minDate, otherMaxDate: maxDate, customValidations: checkCustomValidations, ToDateMin: getBackMonths(TodaysDate, 3), ToDatemax: TodaysDate, customTime: true, showCustomTimeRangeOnly: customTime, setShowCustomTimeRangeOnly: setCustomTime, filterDate: filterDate, rangeFilterDate: rangefilterDate, isDisabled: true, holidayList: holidayList })),
                resDate && (React.createElement(Col, { md: 3, lg: 3, className: "DMSanN_16_400 txt_primaryGrey mt-2 sales-mtf-report-date" },
                    "Date: ",
                    resDate))),
            React.createElement(Table, { className: "lead-table lead-table-width" },
                React.createElement("thead", { className: "DMSansMedium_12_500 txt_primaryGrey mtf-reports-header" },
                    React.createElement("tr", null, columnList.map(function (column, idx) {
                        return (React.createElement("th", { key: idx, onClick: function () { } }, column.title));
                    }))),
                React.createElement("tbody", { className: "DMSanN_14_400 txt_blackOne1 sales-mtf-tbody" },
                    loader && (React.createElement("tr", { className: "border-0 loader-height-row" },
                        React.createElement("td", { className: "position-relative loader-lead border-0", colSpan: 12 },
                            React.createElement(Loader, null)))),
                    !loader && mtfReportData && mtfReportData.length > 0 ? (mtfReportData.map(function (x, i) {
                        return (React.createElement(React.Fragment, null,
                            React.createElement("tr", { className: "bg_monochromeGrey" },
                                React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.transactionDate) ? x === null || x === void 0 ? void 0 : x.transactionDate : "-"),
                                React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.accountCode) ? x === null || x === void 0 ? void 0 : x.accountCode : "-"),
                                React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.clientName) ? x === null || x === void 0 ? void 0 : x.clientName : "-"),
                                React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.stockName) ? x === null || x === void 0 ? void 0 : x.stockName : "-"),
                                React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.quantity) ? x === null || x === void 0 ? void 0 : x.quantity : "-"),
                                React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.status) ? x === null || x === void 0 ? void 0 : x.status : "-"))));
                    })) : (React.createElement("tr", { className: "table-errormsg" },
                        React.createElement("td", { colSpan: 30 },
                            " ",
                            React.createElement("div", { className: "d-flex justify-content-center" }, !loader && (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION }))))))))),
        dateValidation && (React.createElement(SalesToasts, { parentClass: "lead-create-toast assign-lead mtf-report", show: dateValidation, setShow: setDateValidation, position: "middle-center", message: React.createElement("span", { dangerouslySetInnerHTML: { __html: getValidationMessage() } }), isError: true }))));
};
export default MTFReport;
